<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { computed } from 'vue'
import { UserSelect } from '../user-select'
import { toStringArray } from './formkit-utils'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const modelValue = computed(() => toStringArray(props.context.value))
</script>

<template>
  <UserSelect v-bind="context.attrs" :model-value="modelValue" @update:model-value="props.context.node.input" />
</template>
